module.exports = __webpack_public_path__ + "media/src/img/tree-6f6570964a319d741c021cb15afb3387.png";